import React, { useState } from 'react';
import { Check, Star, ShieldCheck, Plus, Minus, Lock } from 'lucide-react';
export const Comparison = () => <section className="bg-brand-bgAlt py-[64px] px-5 md:px-10" data-id="element-195">
    <div className="max-w-[940px] mx-auto" data-id="element-196">
      <h2 className="font-playfair font-bold text-[36px] text-brand-text text-center mb-[40px]" data-id="element-197">
        ¿Qué añade el MegaPack Completo?
      </h2>

      <div className="rounded-[14px] overflow-hidden shadow-[0_4px_24px_rgba(15,30,58,0.10)] bg-white overflow-x-auto" data-id="element-198">
        <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-199">
          <thead data-id="element-200">
            <tr className="bg-brand-dark" data-id="element-201">
              <th className="w-[45%] p-[20px_24px] font-inter font-semibold text-sm text-white/60" data-id="element-202">
                Situación
              </th>
              <th className="w-[27%] p-[20px_24px] font-inter font-semibold text-sm text-white/60 text-center" data-id="element-203">
                Solo MegaPack 1
              </th>
              <th className="w-[28%] p-[20px_24px] font-inter font-semibold text-sm text-brand-accentPremium text-center" data-id="element-204">
                MegaPack Completo
              </th>
            </tr>
          </thead>
          <tbody data-id="element-205">
            {[{
            sit: 'Quieres entender el sueño, el llanto y el desarrollo de tu bebé',
            m1: '✅ Tienes el sistema completo',
            mc: '✅ Tienes el sistema completo'
          }, {
            sit: 'Quieres saber si tu bebé va bien en su desarrollo',
            m1: '✅ Tienes la Tabla de Hitos y el Bono 2',
            mc: '✅ Tienes todo eso más el sistema avanzado'
          }, {
            sit: 'Quieres ir más allá de la supervivencia y potenciar la inteligencia de tu bebé',
            m1: 'No está cubierto en profundidad',
            mc: '✅ DESARROLLO SIN LÍMITES: 15 capítulos sobre cómo estimular la mente de tu bebé de 0 a 2 años'
          }, {
            sit: 'Quieres introducir un segundo idioma de forma natural',
            m1: 'No está cubierto',
            mc: '✅ Método de bilingüismo natural incluido'
          }, {
            sit: 'Quieres desarrollar la atención y la concentración de tu bebé desde pequeño',
            m1: 'No está cubierto',
            mc: '✅ Protocolo completo de desarrollo de la atención'
          }, {
            sit: 'Quieres convertir tu casa en un entorno que favorezca el aprendizaje',
            m1: 'No está cubierto',
            mc: '✅ Guía completa de entorno educativo en casa'
          }, {
            sit: 'Quieres que lo que construyes ahora dure más allá del primer año',
            m1: 'Tienes la base del primer año',
            mc: '✅ Plan de continuidad hasta los 2 años incluido'
          }].map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-brand-bg'} data-id="element-206">
                <td className="p-[20px_24px] border-b border-brand-borderSuave font-inter text-[15px] text-brand-text" data-id="element-207">
                  {row.sit}
                </td>
                <td className="p-[20px_24px] border-b border-brand-borderSuave font-inter text-[14px] text-brand-textSec text-center" data-id="element-208">
                  {row.m1}
                </td>
                <td className="p-[20px_24px] border-b border-brand-borderSuave font-inter font-semibold text-[14px] text-brand-accent text-center" data-id="element-209">
                  <div className="flex items-center justify-center gap-1" data-id="element-210">
                    <Check className="w-4 h-4 text-brand-accentExtra" data-id="element-211" />
                    {row.mc}
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>
  </section>;
export const PremiumBlock = () => <section className="bg-brand-dark py-12 md:py-16 px-4" data-id="element-212">
    <div className="max-w-[1000px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-213">
      <div data-id="element-214">
        <div className="font-inter font-bold text-[11px] text-brand-accentExtra tracking-[2px] uppercase mb-5" data-id="element-215">
          INCLUIDO EN EL MEGAPACK COMPLETO
        </div>
        <h2 className="font-playfair font-bold text-3xl md:text-[38px] text-white mb-2 leading-tight" data-id="element-216">
          DESARROLLO SIN LÍMITES
        </h2>
        <h3 className="font-playfair italic text-lg md:text-[20px] text-white/70 mb-8" data-id="element-217">
          Cómo despertar la inteligencia de tu bebé desde el primer día (0-2
          años)
        </h3>

        <div className="space-y-4" data-id="element-218">
          {[{
          b: 'BLOQUE 1:',
          d: 'El cerebro de tu bebé. Cómo funciona, qué construye su inteligencia y por qué los primeros 2 años son únicos.'
        }, {
          b: 'BLOQUE 2:',
          d: 'Juegos inteligentes para hacer en casa. Tarjetas de imágenes, pre-lectura y números. Todo con lo que tienes en casa. Sin gastar nada.'
        }, {
          b: 'BLOQUE 3:',
          d: 'Tu casa, su mejor escuela. Cómo organizar el entorno para que aprenda solo mientras explora. Sin pantallas necesarias.'
        }, {
          b: 'BLOQUE 4:',
          d: 'Hablar dos idiomas. Método práctico para introducir el inglés aunque tú no lo domines perfectamente.'
        }, {
          b: 'BLOQUE 5:',
          d: 'Un niño que sabe concentrarse. Cómo desarrollar la atención y la paciencia desde los primeros meses. El músculo del futuro.'
        }].map((item, i) => <div key={i} data-id="element-219">
              <div className="font-inter font-bold text-[12px] text-brand-accentExtra tracking-[1px] mb-1" data-id="element-220">
                → {item.b}
              </div>
              <p className="font-inter text-[14px] text-white/70 leading-relaxed" data-id="element-221">
                {item.d}
              </p>
            </div>)}
        </div>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 text-center flex flex-col justify-center h-full" data-id="element-222">
        <div className="font-playfair font-bold text-[80px] text-white leading-none mb-2" data-id="element-223">
          60
        </div>
        <div className="font-inter text-[16px] text-white/60 mb-7" data-id="element-224">
          páginas de contenido premium
        </div>

        <hr className="border-white/10 my-7" data-id="element-225" />

        <div className="font-inter font-semibold text-[16px] text-white/80" data-id="element-226">
          5 bloques · 15 capítulos
        </div>
        <div className="font-inter text-[13px] text-white/50 mt-3" data-id="element-227">
          Incluido solo en el MegaPack Completo
        </div>
      </div>
    </div>
  </section>;
const testimonials2 = [{
  quote: 'El Tomo 1 sobre el sueño me salvó literalmente. Por fin entendí por qué se despertaba tanto y pude hacer algo concreto. La primera semana ya notamos la diferencia.',
  author: 'Miguel A.',
  city: 'Sevilla',
  initial: 'M',
  badge: 'MegaPack Completo'
}, {
  quote: 'El bono de Lo Normal en Cada Mes lo tengo guardado en el móvil y lo consulto cada vez que algo me preocupa. Ha reducido mi ansiedad de forma brutal. Ya no me alarmo por todo.',
  author: 'Sofía T.',
  city: 'Bilbao',
  initial: 'S',
  badge: 'MegaPack 1'
}, {
  quote: 'El Tomo 5 sobre el postparto fue el que más necesitaba y el que menos esperaba. Mi pareja y yo lo leímos juntos y fue la primera conversación real que tuvimos sobre cómo nos sentíamos los dos.',
  author: 'Javier y Laura P.',
  city: 'Málaga',
  initial: 'J',
  badge: 'MegaPack Completo'
}, {
  quote: 'Práctico, directo y sin relleno. Cada tomo va al grano. No es teoría de crianza perfecta. Es información real para situaciones reales.',
  author: 'Carmen L.',
  city: 'Zaragoza',
  initial: 'C',
  badge: 'MegaPack 1'
}, {
  quote: 'Ha sido la mejor inversión del primer año de crianza. Y eso que hemos comprado de todo.',
  author: 'David M.',
  city: 'Alicante',
  initial: 'D',
  badge: 'MegaPack Completo'
}, {
  quote: 'El bono de Respira un Poco lo abrí una noche a las 3 de la madrugada cuando ya no podía más. Fue exactamente lo que necesitaba en ese momento exacto.',
  author: 'Ana R.',
  city: 'Granada',
  initial: 'A',
  badge: 'MegaPack 1'
}];
export const Testimonials2 = () => <section className="bg-brand-bg py-[64px] px-4" data-id="element-228">
    <div className="max-w-[1200px] mx-auto" data-id="element-229">
      <h2 className="font-playfair font-bold text-[32px] text-brand-text text-center mb-[40px]" data-id="element-230">
        Más padres que ya lo tienen
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-231">
        {testimonials2.map((t, i) => <div key={i} className="bg-white rounded-[16px] p-6 md:p-8 shadow-[0_2px_12px_rgba(0,0,0,0.06)] border border-brand-borderDorado relative" data-id="element-232">
            <div className="absolute top-4 right-4 bg-brand-accent/10 text-brand-accent font-inter font-semibold text-[11px] px-2.5 py-1 rounded-full" data-id="element-233">
              {t.badge}
            </div>
            <div className="flex gap-1 mb-4 mt-2" data-id="element-234">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-accentPremium text-brand-accentPremium" data-id="element-235" />)}
            </div>
            <div className="font-playfair font-bold text-[60px] text-brand-accent opacity-15 absolute top-6 left-6 leading-none" data-id="element-236">
              "
            </div>
            <p className="font-inter text-[16px] text-brand-text leading-[1.7] mb-5 relative z-10" data-id="element-237">
              {t.quote}
            </p>
            <hr className="border-brand-borderDorado mb-5" data-id="element-238" />
            <div className="flex items-center gap-3" data-id="element-239">
              <div className="w-11 h-11 rounded-full bg-brand-dark text-white font-inter font-bold text-lg flex items-center justify-center shrink-0" data-id="element-240">
                {t.initial}
              </div>
              <div data-id="element-241">
                <div className="font-inter font-semibold text-[15px] text-brand-text" data-id="element-242">
                  {t.author}
                </div>
                <div className="font-inter text-[13px] text-brand-textSec" data-id="element-243">
                  {t.city}
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </div>
  </section>;
export const Guarantee = () => <section className="bg-brand-bgSpecial py-[64px] px-5 md:px-10" data-id="element-244">
    <div className="max-w-[700px] mx-auto bg-white rounded-[20px] p-[40px_48px] shadow-[0_8px_40px_rgba(15,30,58,0.10)] border-2 border-brand-accent text-center flex flex-col items-center" data-id="element-245">
      <ShieldCheck className="w-[64px] h-[64px] text-brand-accent mb-[20px]" data-id="element-246" />
      <h2 className="font-playfair font-bold text-[32px] text-brand-text mb-[16px]" data-id="element-247">
        Garantía 7 Días — Sin Preguntas
      </h2>
      <p className="font-inter text-base md:text-[16px] text-brand-textSec leading-[1.7] mb-[28px]" data-id="element-248">
        Estamos completamente seguros de que este sistema te va a dar claridad y
        herramientas reales para el primer año con tu bebé. Por eso asumimos
        todo el riesgo nosotros. Tienes 7 días completos para leer los tomos y
        usar las herramientas. Si sientes que no es para ti, nos mandas un email
        y te devolvemos el 100% de tu dinero. Sin preguntas. Sin complicaciones.
      </p>

      <div className="w-[80%] h-[1px] bg-brand-borderSuave mx-auto mb-[20px]" data-id="element-249" />

      <div className="flex flex-col items-center mb-[20px]" data-id="element-250">
        <span className="font-inter text-[14px] text-brand-textSec mb-[4px]" data-id="element-251">
          Tasa de devoluciones actual:
        </span>
        <span className="font-playfair font-bold text-[30px] text-brand-accent" data-id="element-252">
          Menos del 1%
        </span>
      </div>

      <div className="bg-brand-paleBlue border border-brand-accent/22 rounded-[10px] px-[20px] py-[10px] flex items-center gap-2" data-id="element-253">
        <Lock className="w-4 h-4 text-brand-accent" data-id="element-254" />
        <span className="font-inter font-semibold text-[13px] text-brand-accent" data-id="element-255">
          Pago encriptado SSL de 256 bits
        </span>
      </div>
    </div>
  </section>;
const faqs = [{
  q: '¿Es un producto físico o digital?',
  a: 'Es 100% digital. Recibirás acceso inmediato a todos los PDFs en tu correo electrónico en menos de 5 minutos después de la compra. Puedes leerlo en tu móvil, tablet o PC, o imprimirlo si lo prefieres. No hay nada que esperar ni que instalar.'
}, {
  q: '¿Sirve si mi bebé ya tiene varios meses?',
  a: 'Sí. El sistema cubre todo el primer año mes a mes y cada tomo está diseñado para que puedas ir directamente a lo que necesitas ahora sin tener que leer todo desde el principio. El Bono 1 te indica exactamente por dónde empezar según la edad y la situación de tu bebé.'
}, {
  q: '¿Cuándo empezaré a ver resultados?',
  a: 'Depende del tomo y de la situación. Muchas familias reportan claridad inmediata después de leer el primer tomo porque entienden por primera vez qué está pasando con su bebé. Las herramientas prácticas están diseñadas para empezar a usarse el mismo día.'
}, {
  q: '¿Es seguro el pago?',
  a: 'Sí. El pago se procesa con encriptación SSL de 256 bits. Tus datos están completamente protegidos en todo momento.'
}, {
  q: '¿Cómo funciona la garantía?',
  a: 'Tienes 7 días desde la compra para solicitar la devolución completa del importe sin necesidad de dar ninguna explicación. Solo tienes que enviarnos un email a soporte@cherubagency.com y te devolvemos el 100% del dinero.'
}, {
  q: '¿Los tomos y los bonos están en español?',
  a: 'Sí. Todo el sistema está escrito en español, con un lenguaje claro, cercano y sin tecnicismos innecesarios. Está diseñado para ser útil y fácil de leer incluso cuando estás agotado.'
}, {
  q: '¿Qué diferencia hay entre el MegaPack 1 y el MegaPack Completo?',
  a: 'El MegaPack 1 incluye los 6 tomos y los 6 bonos del sistema principal, todo lo necesario para el primer año. El MegaPack Completo añade DESARROLLO SIN LÍMITES, un eBook premium de 60 páginas sobre cómo estimular la inteligencia, el bilingüismo y la capacidad de concentración de tu bebé desde el primer día hasta los 2 años.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-bg py-[64px] px-5 md:px-10" data-id="element-256">
      <div className="max-w-[740px] mx-auto" data-id="element-257">
        <h2 className="font-playfair font-bold text-[36px] text-brand-text text-center mb-[40px]" data-id="element-258">
          Preguntas Frecuentes
        </h2>
        <div className="flex flex-col gap-[12px]" data-id="element-259">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-white rounded-[12px] border border-brand-borderSuave overflow-hidden transition-all ${isOpen ? 'border-l-[4px] border-l-brand-accent rounded-l-none' : ''}`} data-id="element-260">
                <button className="w-full px-[28px] py-[22px] flex justify-between items-center text-left hover:bg-brand-bg/50 transition-colors" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-261">
                  <span className="font-inter font-semibold text-[16px] text-brand-text pr-4" data-id="element-262">
                    {faq.q}
                  </span>
                  <div className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-263">
                    {isOpen ? <Minus className="w-6 h-6 text-brand-accentPremium shrink-0" data-id="element-264" /> : <Plus className="w-6 h-6 text-brand-accent shrink-0" data-id="element-265" />}
                  </div>
                </button>
                <div className={`px-[28px] overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-[24px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-266">
                  <div className="pt-[20px] border-t border-brand-borderSuave font-inter text-[16px] text-brand-textSec leading-[1.68]" data-id="element-267">
                    {faq.a}
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
};
export const FinalCTA = () => <section className="bg-brand-dark py-[64px] px-5 md:px-10" data-id="element-268">
    <div className="max-w-[860px] mx-auto" data-id="element-269">
      <h2 className="font-playfair font-bold text-[32px] text-white text-center mb-[36px]" data-id="element-270">
        ¿Listo para empezar?
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[24px] items-center" data-id="element-271">
        {/* Option 1 - Sistema Completo */}
        <div className="bg-brand-accentPremium/10 border-2 border-brand-accentPremium rounded-[14px] p-[40px_36px] text-center shadow-[0_8px_32px_rgba(212,168,74,0.20)] relative" data-id="element-272">
          <div className="font-inter font-bold text-[11px] text-white/40 tracking-[3px] uppercase mb-2" data-id="element-273">
            OPCIÓN 1
          </div>
          <div className="font-inter font-bold text-[12px] text-brand-accentPremium mb-[12px] uppercase" data-id="element-274">
            ⭐ MÁS ELEGIDO
          </div>
          <h3 className="font-playfair font-bold text-[22px] text-white mb-2" data-id="element-275">
            Sistema Completo
          </h3>
          <div className="font-playfair font-bold text-[48px] text-brand-accentPremium mb-6" data-id="element-276">
            23,97€
          </div>
          <button onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'Purchase', {
              value: 23.97,
              currency: 'EUR'
            });
          }
          window.location.href = 'https://checkout.cherubagency.com/cart/56723135856964:1';
        }} className="bg-brand-accentPremium hover:bg-[#C49840] text-white font-inter font-bold text-[16px] px-[32px] py-[16px] rounded-[8px] shadow-[0_4px_16px_rgba(212,168,74,0.40)] transition-colors w-full" data-id="element-277">
            QUIERO EL SISTEMA COMPLETO
          </button>
        </div>

        {/* Option 2 - MegaPack 1 */}
        <div className="bg-white/6 border border-white/14 rounded-[14px] p-[40px_36px] text-center" data-id="element-278">
          <div className="font-inter font-bold text-[11px] text-white/40 tracking-[3px] uppercase mb-2" data-id="element-279">
            OPCIÓN 2
          </div>
          <h3 className="font-playfair font-bold text-[22px] text-white mb-2" data-id="element-280">
            MegaPack
          </h3>
          <div className="font-playfair font-bold text-[48px] text-white mb-6" data-id="element-281">
            14,97€
          </div>
          <button onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'Purchase', {
              value: 14.97,
              currency: 'EUR'
            });
          }
          window.location.href = 'https://checkout.cherubagency.com/cart/56723135103300:1';
        }} className="bg-white/12 border border-white/25 hover:bg-white/20 text-white font-inter font-bold text-[15px] px-[32px] py-[14px] rounded-[8px] transition-colors w-full" data-id="element-282">
            QUIERO MI MEGAPACK
          </button>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-[24px] mt-[36px]" data-id="element-283">
        {['Pago 100% seguro', 'Acceso en 5 minutos', 'Garantía 7 días'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-284">
              <Check className="w-4 h-4 text-brand-accentExtra" data-id="element-285" />
              <span className="font-inter text-[14px] text-white/50" data-id="element-286">
                {item}
              </span>
            </div>)}
      </div>
    </div>
  </section>;
export const Footer = () => <footer className="bg-brand-darkAlt p-[40px_40px_32px_40px]" data-id="element-287">
    <div className="max-w-[1200px] mx-auto" data-id="element-288">
      <div className="h-[1px] bg-white/8 mb-[36px]" data-id="element-289" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[48px] text-center md:text-left mb-[40px]" data-id="element-290">
        <div className="flex flex-col" data-id="element-291">
          <div className="font-playfair font-bold text-[20px] text-white mb-2" data-id="element-292">
            CHERUB AGENCY™
          </div>
          <p className="font-inter text-[14px] text-white/45 leading-[1.6] mt-[10px]" data-id="element-293">
            El sistema de crianza más claro para el mundo real.
          </p>
        </div>

        <div className="flex flex-col gap-[24px]" data-id="element-294">
          <div className="flex flex-col gap-[8px]" data-id="element-295">
            <a href="mailto:soporte@cherubagency.com" className="font-inter text-[14px] text-white/45 hover:text-brand-accentPremium transition-colors block" data-id="element-296">
              soporte@cherubagency.com
            </a>
            <a href="#" className="font-inter text-[14px] text-white/45 hover:text-brand-accentPremium transition-colors block" data-id="element-297">
              @cherubagency
            </a>
            <a href="#" className="font-inter text-[14px] text-white/45 hover:text-brand-accentPremium transition-colors block" data-id="element-298">
              www.cherubagency.com
            </a>
          </div>

          <div className="text-left font-inter text-[12px] leading-[1.6] text-[#A8B0BC]" data-id="element-299">
            Este producto es material educativo e informativo. No sustituye la
            orientación de un profesional de la salud. Ante cualquier duda sobre
            la salud de tu bebé, consulta siempre con tu pediatra.
          </div>
        </div>
      </div>

      <div className="border-t border-white/7 pt-[32px] flex flex-col items-center" data-id="element-300">
        <div className="font-inter text-[13px] text-white/35 mb-[12px]" data-id="element-301">
          © Cherub Agency™ 2026
        </div>
        <div className="flex gap-2 font-inter text-[12px] text-white/35" data-id="element-302">
          <a href="#" className="hover:text-white/65 transition-colors" data-id="element-303">
            Aviso legal
          </a>
          <span data-id="element-304">·</span>
          <a href="#" className="hover:text-white/65 transition-colors" data-id="element-305">
            Política de privacidad
          </a>
          <span data-id="element-306">·</span>
          <a href="#" className="hover:text-white/65 transition-colors" data-id="element-307">
            Cookies
          </a>
        </div>
      </div>
    </div>
  </footer>;
export default Comparison;